module.exports = __webpack_public_path__ + "static/media/view.125d688c.svg";